import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, useBreakpointValue } from "@chakra-ui/react";

const Dialog = ({ isOpen, onClose, title, children }) => {

  const size = useBreakpointValue({ base: 'xl', sm: 'xs', md: 'xl', lg: 'xl', xl: 'xl', xxl: 'xl' })

  return (<Modal isOpen={isOpen} onClose={onClose} size={size}>
    <ModalOverlay />
    <ModalContent>
      <ModalHeader className="bf-modal-header">{title}</ModalHeader>
      <ModalCloseButton />
      <ModalBody className="bf-modal-body">
        {children}
      </ModalBody>
    </ModalContent>
  </Modal>
  )
}

export default Dialog;